import { FONT } from "@/styles/common";
import theme from "@/styles/theme";
import { Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomWrapper = styled(Flex)`
    flex-direction: column;
    & > label + div {
        > input {
            width: 100%;
            background-color: ${theme.COLOR.gray[100]};
            border: 1px solid ${theme.COLOR.gray[100]};
        }
    }

    & > label {
        ${FONT("pretendard", 14, 300)};
        color: ${theme.COLOR.gray[500]};

        & > span {
        }
    }
`;
